/**
 * Service for geolocation
 *
 * Responsibilities:
 * - Fetch geolocation info.
 */
import type { IGeolocation } from "../types";

import type { ApiClient } from "@/common/api/http/types";

export default class GeoService {
  public constructor(private readonly client: ApiClient) {}

  async getGeolocation(): Promise<IGeolocation> {
    return await this.client.get("/v2/geolocation");
  }
}
